export default "__VITE_ASSET__TNyiZbxl__"